import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=2eb069ea&scoped=true&"
import script from "./index2.vue?vue&type=script&lang=js&"
export * from "./index2.vue?vue&type=script&lang=js&"
import style0 from "./index2.vue?vue&type=style&index=0&id=2eb069ea&prod&lang=scss&scoped=true&"
import style1 from "./index2.vue?vue&type=style&index=1&id=2eb069ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb069ea",
  null
  
)

export default component.exports